import { SystemStatus } from '../../domain/types';

export const getSystemStatus = (): SystemStatus => {
  return {
    lastSyncTime: '2021-04-01T09:25:46.000000+00:00',
  };
};
